const PREFIX = '[charlotte-ui]';

const serialize = (error) => {
  if (!error) {
    return {};
  }
  return {
    error: error.message || String(error),
    stack: error.stack
  };
};

export const logError = (context, error, extra = {}) => {
  try {
    console.error(`${PREFIX} ${context}`, { ...serialize(error), ...extra });
  } catch {
    // Never let logging itself break the caller.
  }
};

export const logWarn = (context, extra = {}) => {
  try {
    console.warn(`${PREFIX} ${context}`, extra);
  } catch {
    // Never let logging itself break the caller.
  }
};
